import {httpRequest} from "../../../utils/HttpRequest";
import {IOrganRemove,IOrganSearch,IOrganUpdate,IOrganInsert,IOrganDetail,IOrganParams,IOrganDisable} from "./orgTypes"
import {IPage} from "../../../types/AppTypes";
export interface IVRMOrgDetail {
    note: string,
    ver: string,
    code: string,
    address: string,
    sourceAuthKey: string,
    pcode: string,
    branch?: string,
    phone: string,
    children: IVRMOrgDetail[],
    enable: number,
    contact: string,
    name: string,
    key: string,
}

class OrganService {
    async page(params:IOrganSearch){
        const apiUrl = "/assets/org/page"
        return await httpRequest.post<IPage<IOrganDetail>>(apiUrl,params)
    }
    async oldPage(params:IOrganSearch){
        const apiUrl = "md/org/page"
        return await httpRequest.post<IPage<IOrganDetail>>(apiUrl,params)
    }
    async insert(params:IOrganInsert){
        const apiUrl = "/assets/org/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IOrganUpdate){
        const apiUrl = "/assets/org/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async remove(params:IOrganRemove){
        const apiUrl = "/assets/org/remove"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IOrganDisable){
        const apiUrl = "/md/org/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const organService = new OrganService()
export {
    organService
}